var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NewItem',{attrs:{"editing":true,"item_target":_vm.item_target,"menu":_vm.menu,"languages":_vm.languages},on:{"item-added":function($event){return _vm.itemAdded()},"close-item-modal":function($event){return _vm.closeModal()}}})}
var staticRenderFns = []

export { render, staticRenderFns }